import React from "react";
import ReactDOM from "react-dom/client";
import "@styles/all.scss";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";

import * as Sentry from "@sentry/react";
import "./sentryInit";
import { installMediaPlayRejectionSuppressor } from "@utils/func/suppressMediaPlayRejection";
import { loadPracticeMerchant } from "@utils/practice/practiceMerchant";

// 掃描頁拆卸時 video.play() 的良性 rejection：必須在 app 層常駐攔截，
// 綁在元件裡會因為「cleanup 先於 DOM 移除」而漏接（見該檔註解）。
installMediaPlayRejectionSuppressor();

// 練習專用 build（REACT_APP_PRACTICE_ONLY=1）：LIFF 會把 rich menu 深連結的子路徑
// 放進 ?liff.state=，正常要靠 liff.init() 讀取後導頁；但練習模式刻意跳過 liff.init
// （不碰 LINE SDK），導致所有 LIFF 連結都落在根路徑 "/" → 被導向 /practice 入口。
// 這裡在 React 啟動前手動把 liff.state 還原成真正路徑，讓深連結正確落地。
if (process.env.REACT_APP_PRACTICE_ONLY === "1" && typeof window !== "undefined") {
  try {
    const liffState = new URLSearchParams(window.location.search).get("liff.state");
    if (liffState) {
      const target = decodeURIComponent(liffState);
      window.history.replaceState(null, "", target.startsWith("/") ? target : `/${target}`);
    }
  } catch {
    // 忽略：解析失敗就照原路徑走
  }
}

const renderApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
    {
      onUncaughtError: Sentry.reactErrorHandler(),
      onCaughtError: Sentry.reactErrorHandler(),
    } as any,
  );

  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<p>抱歉，系統發生了一些錯誤。我們已經在處理了！</p>}>
        <Router>
          <App />
        </Router>
      </Sentry.ErrorBoundary>
    </React.StrictMode>,
  );
};

// 練習專用 build：網址帶 ?shop=<代號> 時，先抓 S3 上的瓦斯行檔案再渲染，
// 讓沙盒裡的假瓦斯行（版頭、訂單、商店資訊）一開頁就是指定的那家（見 practiceMerchant）。
// 抓不到、逾時都照假資料渲染；正式 build 不受影響、照常立即渲染。
if (process.env.REACT_APP_PRACTICE_ONLY === "1") {
  loadPracticeMerchant().finally(renderApp);
} else {
  renderApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
